import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { AttendanceStatus, RequestStatus } from "@/data/mock";

const attendanceStyles: Record<AttendanceStatus, string> = {
  "Present": "bg-success/10 text-success border-success/20",
  "Checked In": "bg-info/10 text-info border-info/20",
  "Checked Out": "bg-primary/10 text-primary border-primary/20",
  "Partial": "bg-warning/10 text-warning border-warning/20",
  "Exception": "bg-destructive/10 text-destructive border-destructive/20",
  "Missed": "bg-muted text-muted-foreground border-border",
  "Outside Geofence": "bg-destructive/10 text-destructive border-destructive/20",
  "Pending Review": "bg-warning/10 text-warning border-warning/20",
};

export function AttendanceStatusBadge({ status, className }: { status: AttendanceStatus; className?: string }) {
  return (
    <Badge variant="outline" className={cn("font-medium", attendanceStyles[status], className)}>
      <span className="mr-1.5 h-1.5 w-1.5 rounded-full bg-current" />
      {status}
    </Badge>
  );
}

const requestStyles: Record<RequestStatus, string> = {
  Pending: "bg-warning/10 text-warning border-warning/20",
  Approved: "bg-success/10 text-success border-success/20",
  Rejected: "bg-destructive/10 text-destructive border-destructive/20",
  "Needs Clarification": "bg-info/10 text-info border-info/20",
};

export function RequestStatusBadge({ status, className }: { status: RequestStatus; className?: string }) {
  return (
    <Badge variant="outline" className={cn("font-medium", requestStyles[status], className)}>
      {status}
    </Badge>
  );
}
